// Imports ------------------------------------------------------------------->

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

import { DateTimeService } from '../services/DateTimeService'

export function normalizeDate(str: string, endOfDay = false): Date {
    const dts = DateTimeService.getInstance()
    return dts.convertTimeToZulu(str, endOfDay)
}
